import { _ } from "i18n";
import { GameAnalysisStatusEnumChoices } from "features/discover/types";
import { DatagridBackendFilterType, DatagridFilterInputType, type FilterConfig } from "../../types";
import {
	DISCOVER_GAMES_PRIORITY_FILTER_OPTIONS,
	DiscoverGamesFilterField,
	DiscoverGamesProviderTagFilterValue,
} from "../constants";

export const analysisFilters = {
	providerAndPriority(): FilterConfig[] {
		return [
			{
				id: DiscoverGamesFilterField.ProviderTag,
				label: _("discover.gamesTable.filter.providerTag"),
				type: DatagridFilterInputType.Select,
				field: DiscoverGamesFilterField.ProviderTag,
				filterType: DatagridBackendFilterType.Exact,
				options: [
					{
						label: _("discover.gamesTable.providerTag.option.any"),
						value: DiscoverGamesProviderTagFilterValue.Any,
					},
					{ label: _("label.bepro"), value: DiscoverGamesProviderTagFilterValue.Bepro },
					{ label: _("label.korastats"), value: DiscoverGamesProviderTagFilterValue.Korastats },
					{ label: _("label.sportlogiq"), value: DiscoverGamesProviderTagFilterValue.Sportlogiq },
					{ label: _("label.ubitrack"), value: DiscoverGamesProviderTagFilterValue.Ubitrack },
					{
						label: _("discover.gamesTable.providerTag.option.none"),
						value: DiscoverGamesProviderTagFilterValue.None,
					},
				],
				placeholder: _("discover.gamesTable.filterPlaceholder.providerTag"),
			},
			{
				id: DiscoverGamesFilterField.GameAnalysisStatus,
				label: _("discover.gamesTable.filter.gameAnalysisStatus"),
				type: DatagridFilterInputType.Select,
				field: DiscoverGamesFilterField.GameAnalysisStatus,
				filterType: DatagridBackendFilterType.Exact,
				options: GameAnalysisStatusEnumChoices,
				placeholder: _("discover.gamesTable.filterPlaceholder.gameAnalysisStatus"),
			},
			{
				id: DiscoverGamesFilterField.Priority,
				label: _("discover.gamesTable.filter.priority"),
				type: DatagridFilterInputType.Multiselect,
				field: DiscoverGamesFilterField.Priority,
				filterType: DatagridBackendFilterType.Inarray,
				options: DISCOVER_GAMES_PRIORITY_FILTER_OPTIONS,
				placeholder: _("discover.gamesTable.filterPlaceholder.priority"),
			},
		];
	},
	analysisRequestedAt(): FilterConfig {
		return {
			id: DiscoverGamesFilterField.AnalysisRequestedAt,
			label: _("discover.gamesTable.filter.analysisRequestedAt"),
			type: DatagridFilterInputType.Daterange,
			field: DiscoverGamesFilterField.AnalysisRequestedAt,
			filterType: DatagridBackendFilterType.Datetimerange,
		};
	},
};
